import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import {
  AlertComponent,
  CardSliderComponent,
  DrawerComponent,
  DropdownComponent,
  FooterComponent,
  HeaderComponent,
  MenuComponent,
  NextPage,
  NpSelectDirective,
  NpSetLayoutDirective,
  NpTableDirective,
  SearchComponent,
  SliderComponent,
  TabbedComponent,
} from '@cvx/nextpage';

const nextpageComponents = [
  AlertComponent,
  CardSliderComponent,
  DrawerComponent,
  DropdownComponent,
  FooterComponent,
  HeaderComponent,
  MenuComponent,
  NpSelectDirective,
  NpSetLayoutDirective,
  NpTableDirective,
  SearchComponent,
  SliderComponent,
  TabbedComponent,
];

@NgModule({
  imports: [CommonModule, NextPage],
  exports: [nextpageComponents]
})
export class NextpageModule { }
